module.exports = __webpack_public_path__ + "static/contact-4f3dccbe15a785cff2f27351bbecb789.jpg";